import React from 'react'
import './index.css';


function ButtonGoogle() {

    const handleOnClick = () => {
        console.log('ok google');
    }
    
    return (

        <button className="lover-button-google" onClick={handleOnClick}>
            <img style={{margin: '0 11px'}} src={require(`../../../assets/icons/google.svg`)} />
            <p>Sign in With Google</p>
        </button>
    )
}

export default ButtonGoogle;

